'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSimilarTyphoons = exports.getSimilarTy = undefined;

var _ZmapHelper = require('./util/ZmapHelper.js');

var getSimilarTy = exports.getSimilarTy = function getSimilarTy(tsid) {
  var angle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 30;
  var anglediff = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 30;
  var speed = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 30;
  var speeddiff = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 30;
  var strength = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 30;

  if (!tsid) return;
  $('#simTyphoon ul .similarTyInner').remove();
  var url = window.PAGE_CONFIG.BASE_URL + '/typhoon/matchTyphoon?fcid=BCGZ&tsid=' + tsid + '&w_windspeed=' + strength + '&w_speed=' + speed + '&w_direction=' + angle + '&w_speed_change=' + speeddiff + '&w_direction_change=' + anglediff + '&_=' + Date.now();
  $.ajax({
    url: url
  }).then(function (data) {
    data = JSON.parse(data);
    if (!data.length) {
      getNoSimi();
      if ($('.simiMatch').hasClass('on')) $('.closeSimi').click();
      removeAllSimTy();
      return;
    }

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var el = _step.value;

        $('#simTyphoon ul').prepend('<li class="similarTyInner" tyid="' + el.tsid + '"><a>' + el.cname + '</a></li>');
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    var simiMatchHeight = $('.simiMatch').height();
    $('.simiMatch').css({
      'transform': 'translateY(0%)',
      bottom: 0
    }).addClass('on');
  });
};

var getSimilarTyphoons = exports.getSimilarTyphoons = function getSimilarTyphoons(tsid) {
  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  var fcid = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'BCGZ';

  if (!tsid) {
    return;
  }
  $('#simTyphoon ul .similarTyInner').remove();
  var url = window.PAGE_CONFIG.BASE_URL + '/typhoon/matchTyphoonByRange?tsid=' + tsid + '&fcid=' + fcid + '&r=' + r;
  $.ajax({
    url: url
  }).then(function (data) {
    if (!data.length) {
      getNoSimi();
      if ($('.simiMatch').hasClass('on')) $('.closeSimi').click();
      removeAllSimTy();
      return;
    }
    $(".typhoon_cusDetales").css("display", "block");
    $(".simiMatchCon").removeClass("ele_hide");
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = data[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var el = _step2.value;

        $('#simTyphoon ul').prepend('<li class="similarTyInner" tyid="' + el.tsid + '"><a>' + el.intlid + ' ' + el.cname + '</a></li>');
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    var simiMatchHeight = $('.simiMatch').height();
    $('.simiMatch').css({
      'transform': 'translateY(0%)',
      bottom: 0
    }).addClass('on');
  }, function (err) {
    getNoSimi();
  });
};

var getNoSimi = function getNoSimi() {
  $('.hint_noSimiTy').fadeIn(1000, function () {
    setTimeout(function () {
      $('.hint_noSimiTy').fadeOut();
    }, 1000);
  });
};

var similarTyLayer = {};
var drawSimilayTy = function drawSimilayTy(tyid, res) {
  if (similarTyLayer[tyid]) {
    map.removeLayer(similarTyLayer[tyid]);
    delete similarTyLayer[tyid];
    return;
  }

  var json = {
    tsid: tyid,
    intlid: res.info && res.info[0] ? res.info[0].intlid : null,
    tscname: res.info && res.info[0] && res.info[0].info && res.info[0].info.cname ? res.info[0].info.cname : null,
    tsename: res.info && res.info[0] && res.info[0].info && res.info[0].info.ename ? res.info[0].info.ename : null,
    real: [],
    fst: []
  };

  if (res.real && Array.isArray(res.real)) {
    res.real.sort(function (a, b) {
      return a.datetime - b.datetime;
    });
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = res.real[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var el = _step3.value;

        var real = formartTyphData(el);
        json.real.push(real);
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }
  }

  if (res.forecast && Array.isArray(res.forecast)) {
    res.forecast.sort(function (a, b) {
      return a.leadtime - b.leadtime;
    });
    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
      for (var _iterator4 = res.forecast[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var opt = _step4.value;

        if (!opt.location.lon || !opt.location.lat) continue;
        var fst = formartTyphData(opt);
        json.fst.push(fst);
      }
    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4.return) {
          _iterator4.return();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }
  }

  var helper = new _ZmapHelper.ZmapHelper(map, window.positionCenter);
  var lyGp = helper.drawTy(json);
  similarTyLayer[tyid] = lyGp.tyLayerGroup;
  map.addLayer(similarTyLayer[tyid]);
  lyGp.layersGoesBack.map(function (el) {
    el.layer.bringToBack();
  });

  var tyReal = json.real,
      realLen = tyReal.length;
  var point = [tyReal[realLen - 1].lat, tyReal[realLen - 1].lon];
  map.setView(point, 4);
};

var removeAllSimTy = function removeAllSimTy() {
  for (var i in similarTyLayer) {
    map.removeLayer(similarTyLayer[i]);
  }similarTyLayer = {};
};

$('#simTyphoon').on('click', '.similarTyInner', function () {
  $(this).toggleClass('simSelected');
  var tyid = $(this).attr('tyid');
  if ($(this).hasClass('simSelected')) {
    var url = window.PAGE_CONFIG.BASE_URL + '/typhoon/findForecastReal?fcid=BCGZ&tsid=' + tyid;
    $.ajax({
      url: url
    }).then(function (data) {
      console.log(data);
      drawSimilayTy(tyid, data);
    });
  } else {
    drawSimilayTy(tyid);
  }
});

function formartTyphData(opt) {
  return {
    time: opt.datetime,
    datetime: new Date(opt.datetime).Format('yyyy/MM/dd HH:mm:ss'),
    leadtime: opt.leadtime || null,
    level: opt.elements.tcrank,
    lon: opt.location.lon,
    lat: opt.location.lat,
    ps: opt.elements.pressure,
    ws: opt.elements.windspeed,
    rr06: opt.elements.rr06 || null,
    rr07: opt.elements.rr07 || null,
    rr08: opt.elements.rr08 || null,
    rr10: opt.elements.rr10 || null
  };
}


//////////////////
// WEBPACK FOOTER
// ./js/getSimilarTy.js
// module id = 26
// module chunks = 0